import React from 'react';
import moment from 'moment-timezone';

/**
 * Obtiene el estado del depósito para Cuentitas basado en la fecha
 * @param {string|Date} depositDate - Fecha del depósito
 * @returns {string} - 'programado' o 'ejecutado'
 */
export const getDepositStatusForCuentita = (depositDate) => {
    const now = moment.utc(); // Hora actual en UTC
    const endOfDayUTC = moment.utc(depositDate).endOf('day');

    // Si la hora actual es anterior o igual al final del día del depósito, es "programado"
    // De lo contrario, es "ejecutado"
    return now.isSameOrBefore(endOfDayUTC) ? "programado" : "ejecutado";
};

/**
 * Renderiza una etiqueta visual (badge) según el estado del depósito
 * @param {string} estado - Estado del depósito
 * @returns {JSX.Element}
 */
export const renderEstado = (estado) => {
    if (!estado) {
        return <span></span>;
    }
    const estadoLowerCase = estado.toLowerCase();
    const isEjecutado = estadoLowerCase === 'ejecutado';
    const isEnviado = estadoLowerCase === 'enviado';
    const isProgramado = estadoLowerCase === 'programado';
    let iconClass = '';

    if (isEjecutado || isEnviado) {
        iconClass = 'fa-check-circle';
    } else if (isProgramado) {
        iconClass = 'fa-clock';
    } else {
        iconClass = 'fa-times-circle';
    }

    const backgroundColor = isEjecutado ? '#0E9600' : isEnviado ? '#3BC5FB' : (isProgramado ? '#F1C901' : '#FF4444');

    return (
        <span style={{
            display: 'inline-block',
            padding: '5px 10px',
            color: 'white',
            backgroundColor,
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: 'bold',
            textAlign: 'center'
        }}>
            <i className={`fa ${iconClass}`} style={{ marginRight: '5px' }}></i>
            {estado.charAt(0).toUpperCase() + estado.slice(1)}
        </span>
    );
};
